import CustomerOrderModelBase from '../_generated/modelBases/customer-order-model-base';

export default class CustomerOrderModel extends CustomerOrderModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
